/**
 * contains the abi and contract address
*/

class SequenceMetadataContract {
    constructor() {
        this.abi = [
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "ipfsHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "user",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "SequenceFavorited",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "ipfsHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "user",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "SequenceStarred",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "ipfsHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "tag",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "SequenceTagged",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "ipfsHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "user",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "SequenceUnfavorited",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "ipfsHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "user",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "SequenceUnstarred",
		"type": "event"
	},
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "ipfsHash",
				"type": "bytes32"
			},
			{
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "favoriteSequence",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "ipfsHash",
				"type": "bytes32"
			},
			{
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "starSequence",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "ipfsHash",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32",
				"name": "tag",
				"type": "bytes32"
			},
			{
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "tagSequence",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "ipfsHash",
				"type": "bytes32"
			},
			{
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "unfavoriteSequence",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "ipfsHash",
				"type": "bytes32"
			},
			{
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "unstarSequence",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	}
        ];

        this.contractAddress = '0x03172e863dbF7EEb3994AF5a6608c470eB6E79fC';
    }

    getContract(web3) {
        return new web3.eth.Contract(this.abi, this.contractAddress);
    }
}

export default SequenceMetadataContract;
	
